import React, { useEffect } from 'react';
import { useHighlightOfferExperiment } from 'src/hooks/experiments';
import { IExperimentProps, IProductNativeAdExperimentProps } from './types';
import { useViewportContext } from 'src/components/viewport/context';

const HighlightOfferExperiment: React.FC<IProductNativeAdExperimentProps> = props => {
  const { isMobile } = useViewportContext();

  return !isMobile && props.highlightsExist ? (
    <Experiment setShowHighlightedOffers={props.setShowHighlightedOffers} />
  ) : null;
};

const Experiment: React.FC<IExperimentProps> = props => {
  const experiment = useHighlightOfferExperiment();
  useEffect(() => {
    props.setShowHighlightedOffers(experiment);
  }, [experiment, props]);

  return null;
};

export default HighlightOfferExperiment;
